import { connect } from 'react-redux'
import { getUserCompanies, hasRoleInCompany, isAuthenticated } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  getCompanyRanking as getCompanyRankingAction,
  toggleCompanyExcludedFromRanking,
} from './store/CompanyRankingActions'
import { CompanyRanking, IDispatchProps, IStateProps } from './CompanyRanking'
import {
  getCompanyRanking,
  getCompanyRankingLoading,
  getPeriodPercentage,
  getCompanyIsExcludedFromRanking,
} from './store/CompanyRankingSelectors'
import { CompanyId, Role } from '../../services/api.types'
import { getStatisticsSelectedCompanyId } from '../Statistics/store/StatisticsSelectors'
import { setSelectedCompanyId } from '../Statistics/store/StatisticsActions'

interface IOwnProps {
  companyId: CompanyId
  month: string
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => ({
  companyId: ownProps.companyId,
  month: ownProps.month,
  authenticated: isAuthenticated(state),
  //userCompanies: getUserCompanies(state),
  periodPercentage: getPeriodPercentage(state),
  companyIsExcludedFromRanking: getCompanyIsExcludedFromRanking(state),
  companyRanking: getCompanyRanking(state),
  companyRankingLoading: getCompanyRankingLoading(state),
  selectedCompanyId: getStatisticsSelectedCompanyId(state),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
})

const mapDispatchToProps: IDispatchProps = {
  getCompanyRankingAction,
  toggleCompanyExcludedFromRanking,
  setSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRanking)
